import { gql } from '@apollo/client';

export const pageVerificationView = gql`
  query pageVerificationView($page: Int!, $amount: Int!, $field: String!, $sort: String!, $filters: [FilterInput!], $csv: Boolean!) {
    pageVerificationView(grid: { amount: $amount, page: $page, field: $field, filters: $filters, sort: $sort, csv: $csv }) {
      data {
        VerifyId
        BarCodeNumber
        Department
        Status
        owner
        VerifyDate
        Type
        source
        UserId
        departmentId
        allComments
      }
      count
    }
  }
`;
